import React from 'react'
import { useHistory } from 'react-router-dom'
import { Formik } from 'formik'

import { Button, Form, Col, Row, Tabs } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import * as ProductoCrud from 'services/producto.service'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeProductoConstant from 'constants/tiposDeProducto'
import ListaDeMonedasConstant from 'constants/listaDeMonedas'

import { TiposTablaPersonalizadaConstant, TiposTablaComunConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as TablaComunService from 'services/tablasComunes.service'
import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'
import * as UbicacionAlmacenamientoCrud from 'services/ubicacionAlmacenamiento.service'

import CodigoFormGroup from './formGroups/codigo'
import CategoriaFormGroup from './formGroups/categoria'
import IndicadorCompraFormGroup from './formGroups/indicadorCompra'
import IndicadorInventarioFormGroup from './formGroups/indicadorInventario'
import IndicadorVentaFormGroup from './formGroups/indicadorVenta'
import MarcaFormGroup from './formGroups/marca'
import MonedaVentasFormGroup from './formGroups/monedaVentas'
import NombreFormGroup from './formGroups/nombre'
import TipoFormGroup from './formGroups/tipo'
import FlagBolsaFormGroup from './formGroups/flagBolsa'
import TipoExistenciaFormGroup from './formGroups/tipoExistencia'
import PesoUnidadFormGroup from './formGroups/pesoUnidad'
import FlagLoteFormGroup from './formGroups/flagLote'
import FlagSegundaImpresionFormGroup from './formGroups/flagSegundaImpresion'
import ModeloFormGroup from './formGroups/modelo'
import TamanioFormGroup from './formGroups/tamanio'
import ColorFormGroup from './formGroups/color'
import DetalleProductoFormGroup from './formGroups/detalleProducto'

import { ValidationSchema } from './validation'

import PresentacionesSection from './sections/presentaciones'
import AfectacionesSection from './sections/afectaciones'
import GruposContablesSection from './sections/gruposContables'

import FamiliaFormGroup from './formGroups/familia'
import SubFamiliaFormGroup from './formGroups/subfamilia'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      const newState = [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
      return newState.sort((a, b) => a.nombreUnidadDeMedida.localeCompare(b.nombreUnidadDeMedida))
    }
    case 'actualizar': {
      const newState = state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val = {
            ...val,
            ...action.payload
          }
        }
        return val
      })

      return newState.sort((a, b) => a.nombreUnidadDeMedida.localeCompare(b.nombreUnidadDeMedida))
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const NuevoMainForm = ({ editarData, handleClose, flagModal, flagEdicion }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const [presentaciones, presentacionesDispatcher] = React.useReducer(
    commonReducer,
    editarData.presentaciones,
    inputArr => {
      if (inputArr) {
        return inputArr.map(x => ({
          ...x,
          _idFila: IdGen.newId()
        }))
      }
      return []
    }
  )

  const detraccionesRef = React.useRef([])
  const retencionesRef = React.useRef([])
  const afectacionesComprasRef = React.useRef([])
  const afectacionesVentasRef = React.useRef([])

  const ubicacionesAlmacenamientoRef = React.useRef([])

  const [gruposContablesCompras, setGruposContablesCompras] = React.useState([])
  const [gruposContablesVentas, setGruposContablesVentas] = React.useState([])
  const [gruposContablesExistencias, setGruposContablesExistencias] = React.useState([])
  const [gruposContablesInventarios, setGruposContablesInventarios] = React.useState([])
  const [gruposContablesVariacion, setGruposContablesVariacion] = React.useState([])
  const [gruposContablesGasto, setGruposContablesGasto] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.AFECTACIONCOMPRA).then(
      ({ data }) => (afectacionesComprasRef.current = data)
    )
    TablaComunService.getAsSelect(TiposTablaComunConstant.AFECTACIONVENTA).then(
      ({ data }) => (afectacionesVentasRef.current = data)
    )
    TablaComunService.getAsSelect(TiposTablaComunConstant.DETRACCION).then(
      ({ data }) => (detraccionesRef.current = data)
    )
    TablaComunService.getAsSelect(TiposTablaComunConstant.RETENCIONES).then(
      ({ data }) => (retencionesRef.current = data)
    )
    UbicacionAlmacenamientoCrud.getUbicacionesAlmacenamiento_Select().then(
      ({ data }) => (ubicacionesAlmacenamientoRef.current = data)
    )
  }, [])

  React.useEffect(() => {
    if (__adminContext.valoresConfiguracionCompania.flagContabilidad) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA).then(({ data }) =>
        setGruposContablesCompras(data)
      )
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA).then(({ data }) =>
        setGruposContablesVentas(data)
      )
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA).then(({ data }) =>
        setGruposContablesExistencias(data)
      )
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO).then(({ data }) =>
        setGruposContablesInventarios(data)
      )
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEVARIACION).then(({ data }) =>
        setGruposContablesVariacion(data)
      )
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEGASTO).then(({ data }) =>
        setGruposContablesGasto(data)
      )
    }
  }, [__adminContext.valoresConfiguracionCompania.flagContabilidad])

  const actualizarGruposContablesCompras = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA).then(({ data }) =>
      setGruposContablesCompras(data)
    )
  }

  const actualizarGruposContablesVentas = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA).then(({ data }) =>
      setGruposContablesVentas(data)
    )
  }

  const actualizarGruposContablesExistencias = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEEXISTENCIA).then(({ data }) =>
      setGruposContablesExistencias(data)
    )
  }

  const actualizarGruposContablesInventarios = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO).then(({ data }) =>
      setGruposContablesInventarios(data)
    )
  }

  const actualizarGruposContablesVariacion = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEVARIACION).then(({ data }) =>
      setGruposContablesVariacion(data)
    )
  }

  const actualizarGruposContablesGasto = () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCONTABLEGASTO).then(({ data }) =>
      setGruposContablesGasto(data)
    )
  }

  const formInitialValues = React.useMemo(
    () => ({
      _idCategoria: editarData._idCategoria || '',
      _idFamilia: editarData._idFamilia || '',
      _idSubFamilia: editarData._idSubFamilia || '',
      _idMarca: editarData._idMarca || '',
      _idDetraccion: editarData._idDetraccion || '',
      _idRetencion: editarData._idRetencion || '',
      _idUbicacionAlmacenamiento: editarData._idUbicacionAlmacenamiento || '',
      afectacionCompra: editarData.afectacionCompra || '1',
      afectacionVenta: editarData.afectacionVenta || '10',
      cuentaContableCompra: editarData.cuentaContableCompra || '',
      cuentaContableInventario: editarData.cuentaContableInventario || '',
      cuentaContableVenta: editarData.cuentaContableVenta || '',
      cuentaContableExistencias: editarData.cuentaContableExistencias || '',
      cuentaContableVariacion: editarData.cuentaContableVariacion || '',
      cuentaContableGasto: editarData.cuentaContableGasto || '',
      codigo: editarData.codigo || '',
      codigoGeneradoFlag: editarData.codigoGeneradoFlag || false,
      flagCompra: editarData.flagCompra ?? true,
      flagInventario: editarData.flagInventario ?? true,
      flagLote: editarData.flagLote ?? false,
      flagVenta: editarData.flagVenta ?? true,
      flagBolsa: editarData.flagBolsa ?? false,
      flagSegundaImpresion: editarData.flagSegundaImpresion ?? false,
      monedaVentas: editarData.monedaVentas || ListaDeMonedasConstant.SOLES,
      nombre: editarData.nombre || '',
      tipo: editarData.tipo || TiposDeProductoConstant.BIEN,
      tipoExistencia: editarData.tipoExistencia,
      descripcion: editarData.descripcion || '',
      pesoUnidad: editarData.pesoUnidad || 1,
      diasReposicion: editarData.diasReposicion || 0,
      modelo: editarData.modelo || '',
      tamanio: editarData.tamanio || '',
      color: editarData.color || '',
      detalleProducto: editarData.detalleProducto || ''
    }),
    [editarData]
  )

  const submitHandler = async data => {
    if (presentaciones.length === 0) {
      __zariContext.snack('error', 'Ingresar presentaciones.')
      return
    }

    if (data.flagCompra && !data.cuentaContableCompra) {
      __zariContext.snack('error', 'Ingresar grupo contable para compras.')
      return
    }

    if (data.flagVenta && !data.cuentaContableVenta) {
      __zariContext.snack('error', 'Ingresar grupo contable para ventas.')
      return
    }

    // Auto-limpieza: si el flag está desmarcado pero quedó la cuenta de una edición previa, la removemos.
    if (!data.flagCompra && data.cuentaContableCompra) {
      data.cuentaContableCompra = ''
    }
    if (!data.flagVenta && data.cuentaContableVenta) {
      data.cuentaContableVenta = ''
    }

    if (editarData._id) {
      await ProductoCrud.actualizarProducto(editarData._id, {
        ...data,
        presentaciones: presentaciones.map(({ _idFila, ...val }) => val)
      })
        .then(() => {
          history.push(`/${CodigosTransaccionesConstant.PRODUCTOS_LISTA}`)
          __zariContext.toast('success', 'El registro se ha actualizado.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      await ProductoCrud.nuevoProducto({
        ...data,
        presentaciones: presentaciones.map(({ _idFila, ...val }) => val)
      })
        .then(() => {
          if (flagModal) {
            __zariContext.toast('success', 'El registro se ha agregado.')
            handleClose()
          } else {
            __zariContext.toast('success', 'El registro se ha agregado.')
            history.push(`/${CodigosTransaccionesConstant.PRODUCTOS_LISTA}`)
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  return (
    <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
      {({ errors, handleChange, isSubmitting, setValues, touched, values, handleSubmit }) => (
        <Form>
          <Row>
            <Col md={12} lg={11} xl={9}>
              <Row>
                <Col xs={12} md={6}>
                  <Row>
                    <Col sm={6} md={12}>
                      <CodigoFormGroup
                        iError={errors.codigo}
                        iTouched={touched.codigo}
                        fIsSubmitting={isSubmitting}
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                        flagEdicion={flagEdicion}
                      />
                    </Col>
                    <Col sm={6} md={12}>
                      <NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} md={12}>
                      <CategoriaFormGroup
                        iError={errors.categoria}
                        iTouched={touched.categoria}
                        fIsSubmitting={isSubmitting}
                        values={values}
                        setValues={setValues}
                        handleChange={handleChange}
                      />
                    </Col>
                    <Col sm={6} md={12}>
                      <FamiliaFormGroup
                        categoriaId={values._idCategoria}
                        iError={errors._idFamilia}
                        iTouched={touched._idFamilia}
                        fIsSubmitting={isSubmitting}
                        values={values}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={6} md={12}>
                      <SubFamiliaFormGroup
                        familiaId={values._idFamilia}
                        iError={errors._idSubFamilia}
                        iTouched={touched._idSubFamilia}
                        fIsSubmitting={isSubmitting}
                        values={values}
                        setValues={setValues}
                      />
                    </Col>
                    <Col sm={6} md={12}>
                      <MonedaVentasFormGroup
                        iError={errors.monedaVentas}
                        iTouched={touched.monedaVentas}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                  {__adminContext.valoresConfiguracionCompania.flagMarcas && (
                    <Row>
                      <Col sm={6} md={12}>
                        <MarcaFormGroup
                          iError={errors._idMarca}
                          iTouched={touched._idMarca}
                          fIsSubmitting={isSubmitting}
                        />
                      </Col>
                    </Row>
                  )}
                  {(values.tipo === TiposDeProductoConstant.BIEN ||
                    values.tipo === TiposDeProductoConstant.ACTIVO_FIJO) && (
                    <>
                      <Row>
                        <Col sm={6} md={12}>
                          <ModeloFormGroup
                            iError={errors.modelo}
                            iTouched={touched.modelo}
                            fIsSubmitting={isSubmitting}
                          />
                        </Col>
                        <Col sm={6} md={12}>
                          <TamanioFormGroup
                            iError={errors.tamanio}
                            iTouched={touched.tamanio}
                            fIsSubmitting={isSubmitting}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6} md={12}>
                          <ColorFormGroup
                            iError={errors.color}
                            iTouched={touched.color}
                            fIsSubmitting={isSubmitting}
                          />
                        </Col>
                        <Col sm={6} md={12}>
                          <DetalleProductoFormGroup
                            iError={errors.detalleProducto}
                            iTouched={touched.detalleProducto}
                            fIsSubmitting={isSubmitting}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col md={12}>
                      <TipoExistenciaFormGroup
                        iError={errors.tipoExistencia}
                        iTouched={touched.tipoExistencia}
                        fIsSubmitting={isSubmitting}
                      />
                      <PesoUnidadFormGroup
                        iError={errors.pesoUnidad}
                        iTouched={touched.pesoUnidad}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} md={6}>
                  <Row>
                    <Col xs={6} sm={4} md={6}>
                      <div className='p-2'>
                        <TipoFormGroup
                          iValue={values.tipo}
                          fIsSubmitting={isSubmitting}
                          values={values}
                          setValues={setValues}
                          handleChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col xs={6} sm={4} md={6}>
                      <div className='p-2'>
                        <IndicadorCompraFormGroup
                          iEnabled={true}
                          iValue={values.flagCompra}
                          fIsSubmitting={isSubmitting}
                        />
                        <IndicadorVentaFormGroup
                          iEnabled={true}
                          iValue={values.flagVenta}
                          fIsSubmitting={isSubmitting}
                        />
                        <IndicadorInventarioFormGroup
                          iEnabled={true}
                          iValue={values.flagInventario}
                          fIsSubmitting={isSubmitting}
                        />
                        <FlagLoteFormGroup
                          iEnabled={true}
                          iValue={values.flagLote}
                          fIsSubmitting={isSubmitting}
                        />
                      </div>
                    </Col>
                    <Col xs={6} sm={4} md={6}>
                      <div className='p-2'>
                        <FlagBolsaFormGroup iValue={values.flagBolsa} fIsSubmitting={isSubmitting} />
                      </div>
                      <div className='p-2'>
                        <FlagSegundaImpresionFormGroup
                          iValue={values.flagSegundaImpresion}
                          fIsSubmitting={isSubmitting}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col md={12}>
              <Tabs defaultActiveKey='1' id='productos-tab'>
                <Tabs.Tab eventKey='1' title='Presentaciones'>
                  <PresentacionesSection
                    vMoneda={values.monedaVentas}
                    presentaciones={presentaciones}
                    dispatch={presentacionesDispatcher}
                  />
                </Tabs.Tab>
                <Tabs.Tab eventKey='2' title='Afectaciones'>
                  <AfectacionesSection
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    touched={touched}
                    isSubmitting={isSubmitting}
                    detracciones={detraccionesRef.current}
                    retenciones={retencionesRef.current}
                    afectacionesCompras={afectacionesComprasRef.current}
                    afectacionesVentas={afectacionesVentasRef.current}
                    ubicacionesAlmacenamiento={ubicacionesAlmacenamientoRef.current}
                  />
                </Tabs.Tab>
                {__adminContext.valoresConfiguracionCompania.flagContabilidad && (
                  <Tabs.Tab eventKey='3' title='Grupos Contables'>
                    <GruposContablesSection
                      values={values}
                      setValues={setValues}
                      errors={errors}
                      touched={touched}
                      isSubmitting={isSubmitting}
                      gruposContablesCompras={gruposContablesCompras}
                      gruposContablesVentas={gruposContablesVentas}
                      gruposContablesExistencias={gruposContablesExistencias}
                      gruposContablesInventarios={gruposContablesInventarios}
                      gruposContablesVariacion={gruposContablesVariacion}
                      gruposContablesGasto={gruposContablesGasto}
                      actualizarGruposContablesCompras={actualizarGruposContablesCompras}
                      actualizarGruposContablesVentas={actualizarGruposContablesVentas}
                      actualizarGruposContablesExistencias={actualizarGruposContablesExistencias}
                      actualizarGruposContablesInventarios={actualizarGruposContablesInventarios}
                      actualizarGruposContablesVariacion={actualizarGruposContablesVariacion}
                      actualizarGruposContablesGasto={actualizarGruposContablesGasto}
                    />
                  </Tabs.Tab>
                )}
              </Tabs>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col md={12} className='text-right'>
              <Button onClick={handleSubmit} className='ml-2'>
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(NuevoMainForm)
